import React from 'react';
import { Helmet } from 'react-helmet';
import Title from '../../components/Title';

export default function PageNotFound() {
    return (
        <div>
            <Helmet>
                <title>Console Defentry - Not found</title>
            </Helmet>
            <Title subText="The page you are looking for might have been removed, had it's name changed or is temporarily unavailable ">
                Page not found
            </Title>
        </div>
    );
}
